import React from 'react'
import { connect } from 'react-redux'
import { fetchFormIfNeeded, setFormValue, postForm } from '~/nodes/actions'
//import axios from 'axios'
import validate from 'validate.js'

class Forms extends React.Component {
  constructor() {
    super();
    // Setting up initial state
    this.state = {
      data: [],
      formValues: {},
      formErrors: {}
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmit = this.handleSubmit.bind(validate);

    this.constraints = {
      name: {
        presence: {allowEmpty: false}
      },
      email: {
        // Email is required
        presence: true,
        // and must be an email (duh)
        email: true
      },
      subject: {
        presence: {allowEmpty: false}
      },
      message: {
        presence: {allowEmpty: false}
      }
    }
  }


  componentWillUnmount() {
    document.getElementsByTagName('body')[0].className = '';
  }

  componentDidUpdate() {
    //amrapApi_load()
  }

  componentDidMount() {
    const { dispatch } = this.props
    document.getElementsByTagName('body')[0].className = 'node';
    dispatch(fetchFormIfNeeded())
    /*var contactForm = "//jeff.4zzz.org.au/webform_rest/elements/contact?_format=json"
    let _this = this;
    axios.get(contactForm)
    .then(function(event) {
      const formData = Object.keys(event.data).map((item, index) => {
        if (!item.match(/^#[\w]+/)){
          item = event.data[item]
          var type = item['#type']
          var name = item['#name']
          if (type !== 'webform_actions') {
            _this.setState((prevState) => {
              prevState.formValues['webform_id'] = item['#webform']
              prevState.formValues[name] = item['#default_value']
              return {formValues: prevState.formValues}
            })
          }
        }
      })
      _this.setState({
        data: event.data
      })
    }) */
  }

  handleChange(event) {
    const { dispatch } = this.props
    var name = event.target.name
    var value = event.target.value

    var obj = {}
    obj[name] = value
    var constraint = _.pick(this.constraints, name)
    console.log(obj)
    console.log(constraint)
    var error = validate(obj, constraint )
    console.log(error)
    this.setState({ formErrors: error })
    this.setState((prevState) => {
      prevState.formValues[name] = value
      return {formValues: prevState.formValues}
    })
    dispatch(setFormValue(name, value))
  }

  handleSubmit(event) {
    event.preventDefault()

    //console.log(validate({password: "bad"}, constraints))
    // => {
    //   "username": ["Username can't be blank"],
    //   "password": ["Password must be at least 6 characters"]
    // }
    var errors = validate(this.props.forms.formValues, this.constraints)

    this.setState({ formErrors: errors })
    // => undefined

    if (errors === undefined) {
      //debugger
      event.preventDefault();
      console.log('Form submitted')
      console.log(this.state.formValues)

      //dispatch(postForm(this.props.forms.formValues))
      /* axios.post('//jeff.4zzz.org.au/webform_rest/submit', this.state.formValues
      )
      .then(function (response) {
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      }) */
    }
  }

  render() {
    var form = []
    const formData = Object.keys(this.props.forms.form).map((item, index) => {
      if (!item.match(/^#[\w]+/)){
        item = this.props.forms.form[item]
        var type = item['#type']
        var name = item['#name']
        form.push(this.props.forms.form[item])

        var error
        if(this.state.formErrors && this.state.formErrors[item['#name']]) {
          error = this.state.formErrors[item['#name']][0]
        }

        switch (type) {
          case 'textfield':
            return (
              <div key={index}>
                <label htmlFor={item['#id']}>{item['#title']}
                <input type="text" id={item['#id']} name={item['#name']} value={this.props.forms.formValues[item['#name']]} size={item['#size']} maxLength={item['#maxlength']} onChange={event => this.handleChange(event, item)} placeholder={item['#title']} />
                </label>
                <p className="error">{error}</p>
              </div>
            )
          case 'email':
            return (
              <div key={index}>
                <label htmlFor={item['#id']}>{item['#title']}
                <input type="email" placeholder={item['#title']} id={item['#id']} name={item['#name']} size={item['#size']} maxLength={item['#maxlength']}  value={this.props.forms.formValues[item['#name']]} onChange={event => this.handleChange(event, item)} />
                </label>
                <p className="error">{error}</p>
              </div>
            )
          case 'textarea':
            return (
              <div key={index}>
                <label htmlFor={item['#id']}>{item['#title']}</label>
                <textarea placeholder={item['#title']} id={item['#id']} name={item['#name']} value={this.props.forms.formValues[item['#name']]} rows={item['#rows']} cols={item['#cols']} onChange={event => this.handleChange(event, item)}></textarea>
                <p className="error">{error}</p>
              </div>
            )
          case 'webform_actions':
            return (
              <div key={index}>
                <input type="submit" id={item.submit['#id']} name={item.submit['#name']} value={this.props.forms.formValues[item.submit['#name']]} />
              </div>
            )
          default:
            return (
              <div key={index}>
                {item['#title']}
              </div>
            )
            break;

        }



      }
    })
    //console.log(this.state.data)

    return (
      <div className="contact-form">
        <form onSubmit={this.handleSubmit}>
          {formData}
        </form>
      </div>
    )
  }
}

export default connect(state => ({forms: state.forms})) (Forms)
